import React from 'react'

function Line({type}:{type: 'solid' | 'light'}) {
    const isSolid = type === 'solid'
  return (
    <div style={{height: isSolid ? 2: 1,background: isSolid ? '#111' : '#f4f4f4',width: '100%'}}></div>
  )
}

export default Line